import { render, staticRenderFns } from "./VoiceConfirmationDialog.vue?vue&type=template&id=b1efc202&"
import script from "./VoiceConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./VoiceConfirmationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports